import { i18n, n, t, type TranslationInterpolations } from ".";
import type { NestedKey } from "../nestedKey";

export const tc = (key: NestedKey<typeof i18n.value.translations>, count: number, interpolation?: TranslationInterpolations) => {
    const formattedCount = n(count, "decimal");
    const value = t(key, { n: formattedCount, count: formattedCount, ...interpolation });

    if (!value) return "";

    const split = value.split("|");
    let index = count;
    if (index > split.length - 1) index = split.length - 1;
    if (index < 0) index = 0;

    return split[index].trim();
};
